import React from 'react';
import { wrap, buttonArea, content } from './style';

interface Props {
  onConfirm: () => void;
  onClose: () => void;
  yesTitle?: string;
  noTitle?: string;
}

function Confirm({
  children,
  yesTitle,
  noTitle,
  onConfirm,
  onClose,
}: React.PropsWithChildren<Props>) {
  return (
    <div css={wrap} role="alertdialog" aria-modal="true">
      <div css={content}>{children}</div>
      <div css={buttonArea}>
        <button type="button" onClick={onClose}>
          {noTitle ? noTitle : '취소'}
        </button>
        <button type="button" onClick={onConfirm} autoFocus>
          {yesTitle ? yesTitle : '확인'}
        </button>
      </div>
    </div>
  );
}

export default Confirm;
